import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-4" }

import RichText from "@/components/base/inputs/RichText.vue";
import { useAMPStore } from "@/store/asset-management-plan";


export default /*#__PURE__*/_defineComponent({
  __name: 'LifeCycleCostModelling',
  props: {
    readonly: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const store = useAMPStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RichText, {
      modelValue: _unref(store).plan.life_cycle_costs,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(store).plan.life_cycle_costs) = $event)),
      label: "7.1 Life Cycle Costs",
      class: "mb-4",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(RichText, {
      modelValue: _unref(store).plan.replacement_value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(store).plan.replacement_value) = $event)),
      label: "7.1.1 Replacement Value",
      class: "mb-4",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(RichText, {
      modelValue: _unref(store).plan.budgets,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(store).plan.budgets) = $event)),
      label: "7.2 Budgets",
      class: "mb-4",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(RichText, {
      modelValue: _unref(store).plan.sustaining_capital_budget,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(store).plan.sustaining_capital_budget) = $event)),
      label: "7.2.1 Sustaining Capital Budget",
      class: "mb-4",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(RichText, {
      modelValue: _unref(store).plan.capital_projects_budget,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(store).plan.capital_projects_budget) = $event)),
      label: "7.2.2 Capital Projects Budget",
      class: "mb-4",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(RichText, {
      modelValue: _unref(store).plan.life_cycle_cost_model,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(store).plan.life_cycle_cost_model) = $event)),
      label: "7.3 Life Cycle Cost Model",
      class: "mb-4",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"]),
    _createVNode(RichText, {
      modelValue: _unref(store).plan.end_of_life,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(store).plan.end_of_life) = $event)),
      label: "7.4 End Of Life",
      class: "mb-4",
      required: "",
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"])
  ]))
}
}

})